//
export default [
    {
        text: "Código interno",
        value: "internal_code",
        width: "15%",
    },
    {
        text: "Alias",
        value: "alias_name",
        width: "15%",
    },
    {
        text: "Nombre",
        value: "name",
    },
    {
        text: "reenvasable",
        value: "is_repackaged",
        align: "center",
        format: "boolean",
        width: "15%",
    },
]